// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__mxGS0","team-container":"Team_team-container__1AL0g"};